import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';
import styles from './IntegrationShopifyModal.module.scss';
import SimpleInput from '../../common/SimpleInput';

function IntegrationShopifyModal(props) {
  const [name, setName] = useState('');

  const submit = (e) => {
    props.submit(name);
    props.onClose();

    e.preventDefault();
  };

  return (
    <ModalWindow open={props.open} onClose={props.onClose} center>
      <form className={styles.form} onSubmit={submit}>
        <h2>Connect your Shopify Account</h2>

        <hr />

        <div className={styles.body}>
          <label>Enter your Store name:</label>
          <div>
            <SimpleInput value={name} onChange={(e) => setName(e.target.value)} />
            <span>.myshopify.com</span>
          </div>
        </div>

        <hr />

        <div className={styles.footer}>
          <p>
            Note: If you can't remember your shop name you can find it by logging into your
            <a href="https://accounts.shopify.com/store-login" target="_blank" rel="noopener noreferrer">
              Shopify admin
            </a>
            and navigating to General Settings -> Store Details.
          </p>

          <div className={styles.button}>
            <Button type="submit" text="OK" disabled={name === ''} />
          </div>
        </div>
      </form>
    </ModalWindow>
  );
}

export default IntegrationShopifyModal;

IntegrationShopifyModal.defaultProps = {
  open: false,
};

IntegrationShopifyModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};
